import _ from 'lodash';

export default {
  props: ['model', 'schema', 'disabled'],

  data() {
    return {
      errors: [],
    };
  },

  computed: {
    value: {
      cache: false,
      get() {
        let val;
        if (_.isFunction(_.get(this.schema, 'get'))) {
          val = this.schema.get(this.model);
        } else {
          val = _.get(this.model, this.schema.model);
        }

        return val;
      },

      set(newValue) {
        let oldValue = this.value;

        if (_.isFunction(newValue)) {
          newValue(newValue, oldValue);
        } else {
          this.updateModelValue(newValue, oldValue);
        }
      },
    },
  },

  methods: {
    updateModelValue(newValue, oldValue) {
      let changed = false;
      if (_.isFunction(this.schema.set)) {
        this.schema.set(this.model, newValue);
        changed = true;
      } else if (this.schema.model) {
        this.setModelValueByPath(this.schema.model, newValue);
        changed = true;
      }

      if (changed) {
        this.$emit('model-updated', newValue, this.schema.model);

        if (_.isFunction(this.schema.onChanged)) {
          this.schema.onChanged.call(this, this.model, newValue, oldValue, this.schema);
        }
      }
    },
    setModelValueByPath(path, value) {
      let s = path.replace(/\[(\w+)\]/g, '.$1');
      s = s.replace(/^\./, '');

      let o = this.model;
      const a = s.split('.');
      let i = 0;
      const n = a.length;
      while (i < n) {
        let k = a[i];
        if (i < n - 1)
          if (o[k] !== undefined) {
            o = o[k];
          } else {
            this.$root.$set(o, k, {});
            o = o[k];
          }
        else {
          this.$root.$set(o, k, value);
          return;
        }

        ++i;
      }
    },
  },
};
